import React from "react";
import { FaUserCheck, FaUsers, FaCode, FaComments, FaFileAlt } from "react-icons/fa";
import image from '../careers/careersImage/hiring-arrow.png'
import hedrabad from '../../../assests/location/download.jpeg'
import usa from '../../../assests/location/usa.jpeg';
import indore from '../../../assests/location/indore.webp'

const jobs = [
  {
    title: "Business Analyst",
    experience: "3–5 years",
    vacancy: "1 Position",
    type: "Full-Time",
    location: 'Gurgaon'
  },
  {
    title: "Ios Developer",
    experience: "2+ Years",
    vacancy: "2 Positions",
    type: "Full-Time",
    location: 'Hyderabad'
  },
  {
    title: "Jr. BDE",
    experience: "0–1 Years",
    vacancy: "2 Positions",
    type: "Full-Time",
    location: 'Bangalore'
  },
  {
    title: "Project Manager",
    experience: "5–8 Years",
    vacancy: "2 Positions",
    type: "Full-Time",
    location: 'Pune'
  },
];

const locations = [
  {
    name: "Indore, India",
    address: "India - 5, Samradhi Park, Indore, Madhya Pradesh 452016",
    img: indore,
  },
  {
    name: "Hyderabad, India",
    address: "Hitech City Rd, Madhapur, Hyderabad, Telangana 500081",
    img: hedrabad,
  },
  {
    name: "USA",
    address: "TekIT Software Delaware, USA - 19958",
    img: usa, // replace with actual URL
  },
  {
    name: "Bangalore, India",
    address: "4th Floor, Building 12, Manyata Tech Park, Bangalore, Karnataka 560045",
    img: "https://deeporion.s3.ap-south-1.amazonaws.com/images/bangloreAddressImg.webp",
  },
];

const processSteps = [
  { icon: <FaUserCheck />, title: "Screening" },
  { icon: <FaUsers />, title: "Technical Interview" },
  { icon: <FaCode />, title: "Practical Round" },
  { icon: <FaComments />, title: "Final HR Discussion" },
  { icon: <FaFileAlt />, title: "Offer Rollout" },
];

const JobSection = ({ setSelectedRole, scrollToForm }) => {
  return (
    <div className="max-w-8xl mx-auto lg:w-[84%] xl:w-[80%] xxl:w-[80%] px-4 py-6 font-recoleta bg-[rgb(249,250,251/var(--tw-bg-opacity))]">
      <section className="py-16 px-4 text-center">
        <h2 className="2xl:text-[40px] lg:text-[32px] text-[68px] font-bold mb-4" data-aos="fade-up">Current Openings</h2>
        {/* <p className="text-gray-600 max-w-5xl 2xl:text-[32px]  lg:text-[26px] text-[38px] mx-auto mb-12" data-aos="fade-up">
          Come be a part of our team and embark on your presence. TekIT is a promising
          organization to give wings to expertise, experience and ingenuity. Explore the jobs
          below and let's make a difference together!
        </p> */}

        <div className="grid gap-6 grid-cols-2 lg:grid-cols-3">
          {jobs.map((job, idx) => (
            <div className="group relative w-full lg:max-w-[23.125rem] sm:min-w-[17rem] min-h-[9rem] p-[2px] overflow-hidden cursor-pointer transform transition-transform duration-300 ease-in-out group-hover:scale-105"
              onClick={() => {
                setSelectedRole(job.title);
                scrollToForm();
              }}
            >
              {/* Border animation layer */}
              <div className="absolute inset-0 z-0 bg-gradient-to-tr from-transparent hover:via-[#09588D] to-transparent group-hover:animate-border-fill" />

              {/* Inner card */}
              <div className="relative z-1 w-full h-full p-5 flex flex-col items-center justify-start bg-gray-100 rounded-[10px] border border-[#F3F6FD] gap-2">
                <div className="w-full flex items-start justify-start gap-4">
                  <div className="h-10 w-10 flex items-center justify-center rounded">
                    <svg
                      stroke="#f76b4f"
                      fill="#f76b4f"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="w-[1.65025rem] h-[1.375rem]"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5" />
                    </svg>
                  </div>
                  <div className="w-full flex flex-col justify-center items-start gap-[2px]">
                    <p className="capitalize leading-6 text-[#031B59] 2xl:text-[26px] lg:text-[20px] text-[28px]">{job.title}</p>
                    <p className="leading-[18px] text-[#646978] line-clamp-1 capitalize 2xl:text-[20px] lg:text-[16px] text-[24px] mt-4">{job.experience}</p>
                  </div>
                </div>

                <div className="w-full flex flex-wrap items-center justify-start gap-[10px] ml-20 mt-2">
                  <div className="w-fit h-[1.75rem] px-2 flex items-center justify-center rounded bg-[#F3F6FD]">
                    <p className="2xl:text-[20px] lg:text-[16px] text-[24px] text-[#646978] leading-[22px] capitalize">{job.type}</p>
                  </div>
                  <div className="w-fit h-[1.75rem] px-1 flex items-center justify-center rounded bg-[#F3F6FD]">
                    <p className="2xl:text-[20px] lg:text-[16px] text-[24px] text-[#646978] leading-[22px]">{job.location}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </section>
      {/* <section className="py-16 px-4 text-center bg-white">
        <h2 className="text-[28px] 2xl:text-[40px] lg:text-[32px] font-bold mb-4 text-black" data-aos="fade-up">Our Process of Recruiting</h2>
        <p className="text-gray-600 text-[32px] md:text-lg mb-12" data-aos="fade-up">Take your career to new heights in a few steps.</p>

        <div className="grid lg:grid-cols-5 grid-cols-1 gap-6 justify-center items-start">
          {processSteps.map((step, idx) => (
            <div
              key={idx}
              className="relative bg-white border-[3px] border-[#F86F4B] rounded-[40px] p-6 flex flex-col items-center justify-center shadow-md hover:shadow-lg transition min-h-[200px]"
            >
              <div className="text-[#09588D] text-5xl mb-4">{step.icon}</div>
              <p className="text-[24px] font-medium text-gray-800">{step.title}</p>

              {idx < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 right-[-20px] transform -translate-y-1/2">
                  <img src={image} className="w-6 h-4 lg:ml-[165px] 2xl:ml-[218px]  border-[#fe4e4e] " />
                </div>
              )}
            </div>
          ))}
        </div>
      </section> */}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-fit mx-auto px-4 py-8">
        {locations.map((location, index) => (
          <div key={index} className="relative w-full h-full max-w-[22rem] text-center">
            <img
              src={location.img}
              alt={location.name}
              className="h-full w-[30.875rem]"
              loading="lazy"
            />
            <div className="w-full h-full group hover:bg-black/50 absolute top-0 left-0 flex items-end justify-center">
              <div className="w-full h-full px-[4px] py-2 flex flex-col gap-1 justify-end">
                <p className="2xl:text-[18px] lg:text-[16px] text-lg text-white font-semibold leading-[26px] 2xl:mb-[15px] lg:mb-[0px]">{location.name}</p>
                <p className="2xl:text-[18px] lg:text-[14px] text-lg leading-tight text-white hidden lg:group-hover:block 2xl:mb-[15px] lg:mb-[0px]">{location.address}</p>
              </div>
            </div>
          </div>
        ))}
      </div>


    </div>
  );
};

export default JobSection;
